module.exports = __webpack_public_path__ + "static/media/Heavy_truck.983b4f3c.jpg";